import React from 'react';
import theme from '@/styles/theme';
import { SVGIconType } from '@/components/icons/svg-icon-types';

export interface MapTrifoldIconProps extends SVGIconType {
  className?: string;
}

const MapTrifoldIcon = ({ width = 16, color, ...props }: MapTrifoldIconProps) => {
  let defaultColor = color ? theme.color[color] : 'black';
  let height = props.height || width;
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.4613 6.40876C28.3714 6.33861 28.2667 6.28988 28.1551 6.26627C28.0436 6.24266 27.9281 6.2448 27.8175 6.27251L20.0875 8.20501L12.3375 4.33001C12.1772 4.25008 11.9937 4.23013 11.82 4.27376L3.82 6.27376C3.65761 6.31391 3.51329 6.4072 3.41001 6.53879C3.30673 6.67039 3.25041 6.83273 3.25 7.00001V25C3.24999 25.114 3.27599 25.2266 3.32601 25.3291C3.37603 25.4315 3.44876 25.5212 3.53867 25.5914C3.62857 25.6615 3.73329 25.7102 3.84486 25.7338C3.95642 25.7574 4.0719 25.7553 4.1825 25.7275L11.9125 23.795L19.6625 27.67C19.8228 27.7499 20.0063 27.7699 20.18 27.7263L28.18 25.7263C28.3424 25.6861 28.4867 25.5928 28.59 25.4612C28.6933 25.3296 28.7496 25.1673 28.75 25V7.00001C28.75 6.886 28.724 6.77349 28.6739 6.67103C28.6239 6.56858 28.5512 6.47889 28.4613 6.40876ZM12.75 6.21376L19.25 9.46376V25.7863L12.75 22.5363V6.21376ZM4.75 7.58876L11.25 5.96376V22.415L4.75 24.04V7.58876ZM27.25 24.415L20.75 26.04V9.58501L27.25 7.96001V24.415Z"
        fill={defaultColor}
      />
    </svg>
  );
};

export default MapTrifoldIcon;
